<template>
	<v-btn outlined @click="triggerFileInput()" :disabled="renderDisableUpload"> 					
		<v-file-input
			dense			
		  hide-details hide-input
		  v-model = "file"								
			:loading = "infoUpload.loadingVideo"
			accept = "video/*"
			@change="onVideoUpload"
			class="mt-0"
			prepend-icon="mdi-video"
			ref="uploadVideo"			
		>{{$ml.get('upload_video')}}</v-file-input>				
		<!-- <div
	        class="drag-drop-area"
	        @dragover.prevent
	        @drop.prevent="onDrop"
	      >
	        <p v-if="!dragging">Arrastra y suelta tu video aquí o selecciona un archivo</p>
	        <p v-else>¡Suelta tu video aquí!</p>
	      </div> -->
		{{$ml.get('upload_video')}}
	</v-btn>
</template>
<style scoped>
.file-button {
  display: inline-block;
  width: 100%;
}
.drag-drop-area {
  border: 2px dashed #ccc;
  border-radius: 8px;
  padding: 16px;
  text-align: center;
  cursor: pointer;
  transition: background-color 0.3s ease;
}
.drag-drop-area:hover {
  background-color: #f5f5f5;
}
.drag-drop-area.dragging {
  background-color: #e3f2fd;
  border-color: #2196f3;
}
</style>

<script type="text/javascript">
	export default{
		name : "UploadVideoSearch",
		props: ["infoUpload"],
		data :()=>({
			file: null,
			loading : false,
		}),
		computed:{
			renderDisableUpload(){
				// console.log( "this.infoUpload.loadingVideo " , this.infoUpload.loadingVideo, this.infoUpload.isUploadingVideo )
				// return true
				return this.infoUpload.isUploadingVideo ? true : false;
			}
		},
		methods: {
			triggerFileInput(){				
				this.$refs.uploadVideo.$el.querySelector('input[type="file"]').click();
			},
			onVideoUpload(file){
				if (file && file instanceof File) {
					this.infoUpload.videoFile=file;
					this.infoUpload.uuid = this.$Helper.generateUUIDv4();//crypto.randomUUID();
					if(this.infoUpload.videoUrl){
						URL.revokeObjectURL(this.infoUpload.videoUrl)
					}
			    this.infoUpload.videoUrl = URL.createObjectURL(file);			    
			    
			    const timer=setTimeout(()=>{			    		
			    	// this.infoUpload.videoUrl
			    	this.infoUpload.videos.unshift({
			    		urlVideo: URL.createObjectURL(file), 
			    		uuid:this.infoUpload.uuid, 
			    		file:file,
			    		urlVideoPreload :   this.infoUpload.videoUrl,
			    		msg: this.$ml.get("uploading_video"), 
			    		isInvalid: false, 
			    		isValid: false, 
			    		loading: true,
			    		needsBlobLoading: true, // Videos subidos necesitan blob loading
			    		loadingBlob: false,
			    		loadingProgress: 0,
			    		loadingTimeout: false
			    	})
			    	clearTimeout(timer)
			    },100)
	      } else {
	        this.infoUpload.videoUrl = null;
	      }
			},
			onDrop(event) {			
			  	const file = event.dataTransfer.files[0];
			  	if (file && file.type.startsWith("video/")) {
			    	this.onVideoUpload(file);
			  	}
			  	this.dragging = false;
			},
		}
	}
</script>